@if (useModal) {
    <organism-modal
        [modalTitle]="title"
        [hideClose]="hideCloseModal"
        (modalClosed)="modalClosed.emit()"
    >
        <ng-container *ngTemplateOutlet="documentContent"></ng-container>
    </organism-modal>
}

@if (!useModal) {
    <section class="h-100">
        <ng-container *ngTemplateOutlet="documentContent"></ng-container>
    </section>
}

<ng-template #documentContent>
    @if (
        {
            activeDocument: activeDocument$ | ngrxPush,
            documents: documents$ | ngrxPush,
        };
        as data
    ) {
        <atom-async-data [isLoading]="!data">
            <div class="d-flex flex-column flew-grow-1 h-100">
                @if (!hideFileList) {
                    <div
                        class="grid gap-0 bg-body document-preview-menu-header"
                    >
                        @if (!hideFileList) {
                            <div class="g-col-12 g-col-lg-4">
                                <div class="p-2 d-lg-none">
                                    <ng-select
                                        placeholder="Select"
                                        (change)="onSelect($event)"
                                    >
                                        @for (
                                            document of data?.documents;
                                            track $index
                                        ) {
                                            <ng-option [value]="document">{{
                                                document.fileIndex?.name
                                            }}</ng-option>
                                        }
                                    </ng-select>
                                </div>
                                <wdx-icon-button
                                    class="d-none d-lg-flex text-nowrap border-end border-gray-200 ms-2 my-2"
                                    (wdxOnClick)="toggleFileList()"
                                >
                                    <wdx-icon icon="bars"></wdx-icon>
                                </wdx-icon-button>
                            </div>
                        }
                        @if (!data?.activeDocument && hideFileList) {
                            <div class="g-col-12 g-col-lg-4">
                                <div
                                    class="d-none d-lg-inline-block text-nowrap border-gray-200 ms-2 my-2"
                                >
                                    <wdx-icon-button
                                        (wdxOnClick)="toggleFileList()"
                                    >
                                        <wdx-icon icon="bars"></wdx-icon>
                                    </wdx-icon-button>
                                </div>
                            </div>
                        }
                        @if (data?.activeDocument) {
                            <div
                                [class.g-col-lg-8]="!hideFileList"
                                class="g-col-12 d-none d-lg-block"
                            >
                                <div
                                    class="d-flex p-2 align-items-center justify-content-center"
                                >
                                    @if (hideFileList) {
                                        <wdx-icon-button
                                            class="text-nowrap border-end border-gray-200 pe-2 me-2"
                                            (wdxOnClick)="toggleFileList()"
                                        >
                                            <wdx-icon icon="bars"></wdx-icon>
                                        </wdx-icon-button>
                                    }
                                    <button
                                        class="btn btn-outline-primary"
                                        [disabled]="
                                            data?.documents?.length > 0 &&
                                            data.documents[0]?.documentId ===
                                                data?.activeDocument?.documentId
                                        "
                                        (click)="
                                            ($event.preventDefault); onBack()
                                        "
                                    >
                                        {{
                                            BACK_BTN | translateTokenisedString
                                        }}
                                    </button>
                                    <span
                                        class="text-truncate fw-bold ms-auto me-auto"
                                        >{{ data?.activeDocument?.name }}</span
                                    >
                                    <div class="d-flex align-items-center">
                                        <atom-icon-button
                                            class="me-4"
                                            size="md"
                                            [icon]="ICON_DOWNLOAD"
                                            [disabled]="
                                                !data?.activeDocument?.fileIndex
                                            "
                                            (click)="onDownloadDocument()"
                                        >
                                        </atom-icon-button>
                                        @if (
                                            mode ===
                                            DOCUMENT_PREVIEW_MODE.AttachFiledDocuments
                                        ) {
                                            <molecule-action-button
                                                class="me-4"
                                                size="md"
                                                [actionButton]="{
                                                    mode: ACTION_BUTTON_MODE.LinkedButton,
                                                    isToggledOn:
                                                        linkedIds?.includes(
                                                            data?.activeDocument
                                                                ?.documentId
                                                        ),
                                                }"
                                                (onClick)="
                                                    onLinkToggled(
                                                        $event,
                                                        data?.activeDocument
                                                            ?.documentId
                                                    )
                                                "
                                            ></molecule-action-button>
                                        }
                                        <button
                                            class="btn btn-outline-primary"
                                            [disabled]="
                                                data?.documents?.length &&
                                                data.documents[
                                                    data.documents.length - 1
                                                ]?.documentId ===
                                                    data?.activeDocument
                                                        ?.documentId
                                            "
                                            (click)="onNext()"
                                        >
                                            {{
                                                NEXT_BTN
                                                    | translateTokenisedString
                                            }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
                <div class="grid gap-0 border document-preview-menu-content">
                    @if (!hideFileList) {
                        <div
                            class="g-col-4 h-100 border-end border-gray-200 p-0 d-none d-lg-flex overflow-hidden flex-column"
                        >
                            <div
                                class="d-none d-lg-flex p-2 align-items-center border-end border-gray-200 flex-0"
                            >
                                <span
                                    class="fw-bold text-nowrap border-end border-gray-200 pe-2 me-2"
                                    >{{ totalRecords }}</span
                                >
                                @if (
                                    mode !== DOCUMENT_PREVIEW_MODE.PreviewOnly
                                ) {
                                    <div class="input-group">
                                        <div class="input-group-text">
                                            <wdx-icon icon="search"> </wdx-icon>
                                        </div>
                                        <input
                                            type="search"
                                            inputmode="search"
                                            wdxInputText
                                            [placeholder]="
                                                PLACEHOLDER_SEARCH_DOCUMENTS
                                                    | translateTokenisedString
                                            "
                                            [(ngModel)]="searchText"
                                            (ngModelChange)="onSearch($event)"
                                        />
                                    </div>
                                }
                            </div>
                            <div
                                class="overflow-auto list-group-flush flex-1"
                                clmiInfiniteScroll
                                (scrolled)="onInfinityScrollFired()"
                            >
                                <atom-async-data
                                    [isLoading]="isLoading$ | ngrxPush"
                                    [isForInfinityScroll]="
                                        data?.documents?.length > 0
                                    "
                                >
                                    @for (
                                        document of data?.documents;
                                        track $index
                                    ) {
                                        <button
                                            #menuItem
                                            class="d-flex text-primary fw-bold border-none list-group-item list-group-item-action align-items-center"
                                            [ngClass]="{
                                                active:
                                                    document?.documentId ===
                                                    data?.activeDocument
                                                        ?.documentId,
                                            }"
                                            (click)="onSelect(document)"
                                        >
                                            @if (
                                                document.fileIndex.contentType
                                                    | fileTypeAsIcon;
                                                as fileType
                                            ) {
                                                <wdx-icon-container
                                                    class="bg-icon me-2 flex-shrink-0 file-type-{{
                                                        fileType.fileType
                                                    }}"
                                                    size="md"
                                                >
                                                    <wdx-icon
                                                        [icon]="fileType.icon"
                                                    ></wdx-icon>
                                                </wdx-icon-container>
                                            }
                                            <div class="text-truncate">
                                                <div class="text-trunate">
                                                    {{ document.name }}
                                                </div>
                                                <div
                                                    class="fw-normal text-body text-truncate"
                                                >
                                                    {{
                                                        document.fileIndex
                                                            | fileName
                                                    }}
                                                </div>
                                            </div>
                                        </button>
                                    }
                                    @if (
                                        !(isLoading$ | ngrxPush) &&
                                        data?.documents?.length === 0
                                    ) {
                                        <div
                                            class="d-flex align-items-center justify-content-center h-100"
                                        >
                                            <atom-feature-svg
                                                [svg]="FEATURE_SVG.NoData"
                                            >
                                                {{
                                                    NO_DOC_MATCHING
                                                        | translateTokenisedString
                                                }}
                                                <span class="fw-bolder">{{
                                                    searchText
                                                }}</span
                                                >.</atom-feature-svg
                                            >
                                        </div>
                                    }
                                </atom-async-data>
                            </div>
                        </div>
                    }
                    <div
                        [class.g-col-lg-8]="!hideFileList"
                        class="g-col-12 h-100 bg-muted"
                    >
                        @if (data?.activeDocument) {
                            <div class="p-4 h-100">
                                <clmi-document-preview-pane
                                    [filePreview]="filePreview$ | ngrxPush"
                                    [isLoading]="
                                        filePreviewIsLoading$ | ngrxPush
                                    "
                                    [hasError]="filePreviewHasError$ | ngrxPush"
                                    (download)="onDownloadDocument()"
                                ></clmi-document-preview-pane>
                            </div>
                        }
                        @if (!data?.activeDocument) {
                            <div
                                class="d-flex align-items-center justify-content-center h-100"
                            >
                                <atom-feature-svg
                                    [svg]="FEATURE_SVG.NoListData"
                                    size="md"
                                >
                                    <div class="mb-2">
                                        {{
                                            SELECT_DOCUMENT
                                                | translateTokenisedString
                                        }}
                                    </div>
                                    @if (permittedTypes) {
                                        <div>
                                            Permitted
                                            {{
                                                'type'
                                                    | pluralString
                                                        : permittedTypes.length
                                                        : 'types'
                                            }}
                                            @for (
                                                docType of permittedTypes;
                                                track $index;
                                                let last = $last
                                            ) {
                                                "{{ docType | titleCase }}"
                                            }
                                        </div>
                                    }
                                </atom-feature-svg>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </atom-async-data>
    }
</ng-template>
